<template>
  <div v-if="activeUploads.length > 0" class="active-uploads">
    <h4 class="active-uploads__title">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
        <polyline points="17,8 12,3 7,8" />
        <line x1="12" y1="3" x2="12" y2="15" />
      </svg>
      Upload in Progress
    </h4>
    <ActiveUploadCard
      v-for="task in activeUploads"
      :key="task.id"
      :task="task"
      @retry="handleRetry"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted, ref } from "vue";
import { miaUploadService } from "../../services/uploadService";
import ActiveUploadCard from "./ActiveUploadCard.vue";

export default {
  name: "ActiveUploadsWidget",
  components: {
    ActiveUploadCard,
  },
  props: {
    featureType: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const uploads = ref([]);

    const activeUploads = computed(() => {
      if (props.featureType) {
        return miaUploadService.pendingUploadsForFeature(props.featureType);
      }
      return miaUploadService.pendingUploads;
    });

    const updateUploads = () => {
      uploads.value = [...miaUploadService.uploads];
    };

    const handleRetry = (id) => {
      miaUploadService.retryUpload(id);
    };

    const handleCancel = (id) => {
      miaUploadService.cancelUpload(id);
    };

    onMounted(() => {
      miaUploadService.addListener(updateUploads);
      updateUploads();
    });

    onUnmounted(() => {
      miaUploadService.removeListener(updateUploads);
    });

    return {
      activeUploads,
      handleRetry,
      handleCancel,
    };
  },
};
</script>

<style scoped>
.active-uploads {
  padding: 12px 16px;
  margin-bottom: 16px;
}

.active-uploads__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 12px 0;
}

.active-uploads__title svg {
  color: #6366f1;
}
</style>
